Promise.all([import(/* webpackMode: "eager" */ './accordion-block.scss')]).then(() => {
  $('.widget.accordion-block').each(function (i, el) {
    $(el).data('widget', new AccordionBlock(el))
    $(el).data('widget').init()
  })
})

function AccordionBlock(el) {
  const self = this
  self.el = $(el)
  self.toggles = self.el.find('[aria-controls]')
  console.log('toggles', self.toggles)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AccordionBlock init', self)
    }

    if (!self.toggles) return

    self.bindEvents()
  }

  self.bindEvents = function () {
    self.toggles.each(function (i, el) {
      el.addEventListener('click', (e) => self.togglePanel(e.currentTarget))
    })
  }

  self.togglePanel = function (toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
    const toggleControls = toggle.getAttribute('aria-controls') || ''
    const panel = document.getElementById(toggleControls)
    toggle.setAttribute('aria-expanded', String(!isExpanded))
    panel?.setAttribute('aria-hidden', String(isExpanded))
  }
}
